import Buttons from '@klv/molecules/buttons';
import { useWindowDimensions } from '@klv/hooks/useWindowDimensions';
import { generateClassName } from '@klv/shared/utils/functions';

import { accentColorShouldBeLemon } from './utils/functions';

import * as styles from './styles/blogHeroSlide.module.scss';

import type { IBlogHeroSlide } from './types';

const BlogHeroSlide = ({
  backgroundColor = 'cedar',
  buttons,
  className,
  controls,
  headline,
  image,
  indicator,
  ...props
}: IBlogHeroSlide) => {
  const textColor = accentColorShouldBeLemon(backgroundColor) ? 'light' : 'dark';

  return (
    <div
      className={generateClassName([
        'blogHeroSlide',
        className,
        styles.blogHeroSlide,
        styles[`${textColor}Text`],
      ])}
      style={{
        backgroundColor: `var(--color-${backgroundColor})`,
      }}
      {...props}
    >
      <div className={generateClassName(['grid', styles.grid])}>
        <div className={styles.textColumn}>
          {useWindowDimensions().width <= 576 ? null : controls && (
            <div className={generateClassName([styles.controlsContainer, styles.fullWidth])}>
              {controls}
            </div>
          )}
          <div className={generateClassName([styles.headline, styles.fullWidth])}>{headline}</div>
          {buttons?.length && (
            <Buttons
              buttons={buttons}
              buttonColor={textColor}
              className={generateClassName([styles.buttons, styles.fullWidth])}
              variants={['primary']}
            />
          )}
          {indicator && (
            <div className={generateClassName([styles.indicatorContainer, styles.fullWidth])}>{indicator}</div>
          )}
        </div>
        <div className={generateClassName([styles.imageColumn, styles.fullWidth])}>
          {image?.sourceUrl ? (
            <img
              alt={image?.altText}
              className={styles.image}
              height={392}
              sizes='(max-width: 690px) 100vw, 690px'
              src={image?.sourceUrl}
              srcSet={image?.srcSet}
              width={690}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default BlogHeroSlide;
